<template>
  <page-wrap>
    <grid :config="gridConfig"/>
    <editor :config="{id: gridConfig.id, api: 'Invoices/Get/'}"/>
  </page-wrap>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'InvoicesIndex',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Grid' */ '@/components/Layouts/PageWrap'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Invoices' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
